import React, {Fragment} from 'react';
import {Popup} from 'components';
import {useNamedSelector, toggle, includes} from 'helpers';
import {store} from 'store';

export function PopupExternalCalendars() {
  const { externalCalendars } = useNamedSelector('settings.settings');
  return (
    <Fragment>
      <Popup.Menu.SubHeading>Display events from</Popup.Menu.SubHeading>
      <Popup.Menu.Checkbox onClick={() => toggleCalendars('icloud')} checked={includes(externalCalendars, 'icloud')}>iCloud Calendar</Popup.Menu.Checkbox>
      <Popup.Menu.Checkbox onClick={() => toggleCalendars('google')} checked={includes(externalCalendars, 'google')}>Google Calendar</Popup.Menu.Checkbox>
    </Fragment>
  );
}

function toggleCalendars(value) {
  store.dispatch({
    type: 'UI_SETTING',
    key: 'externalCalendars',
    value: current => toggle(current, value, {separator: ', '})
  });
}
